import "./SinglePostTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import FooterInformation from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SinglePostTemplateSection />
      <FooterInformation />
    </div>
  )
}
